// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it will be compiled.

require('@rails/ujs').start();
import { bars } from '../js/builder/form';
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import '@babel/polyfill';
import '../scss/main';

window.addEventListener('DOMContentLoaded', () => {
  let form = document.getElementById('BuilderForm');
  if (form) {
    bars();

    const uploader = document.querySelector('#builder_image_id');

    uploader.addEventListener('change', () => {
      const image = document.getElementById('image');
      const file = uploader.files[0];
      var reader = new FileReader();
      reader.addEventListener('load', (e) => {
        var maxExceededMessage =
          'This file exceeds the maximum allowed file size (4 MB)';
        var maxFileSize = 4000000;

        if (file.size > maxFileSize) {
          window.alert(maxExceededMessage); // eslint-disable-line no-alert
          uploader.value = '';
          return;
        }
        image.src = e.target.result;
      });
      reader.readAsDataURL(file);
    });

    document.getElementById('clearForm').onclick = (e) => {
      e.preventDefault();
      form.reset();
      document.getElementById('image').src =
        'https://cdn.ramseysolutions.net/media/b2c/conprod/disc/DISC-builder-form-assets-blank-photo@2x.png';
      let b = new bars();
      b();
    };
  }
});
